// App.js
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";

import Layout from "./components/Layout";
import ScrollToTop from "./components/ScrollToTop";

import Home from "./pages/Acceuil";
import Activities from "./pages/events/activities";
import Statuts from "./pages/statuts";
import Contact from "./pages/contact";
import Donate from "./pages/donation";
import PaymentSuccess from "./pages/PaymentSuccess";   
import Creation from "./pages/events/creation";
import Vivap24 from "./pages/events/vivap24";
import Vivap25 from "./pages/events/vivap25";
import WelcomeApero from "./pages/events/welcomeApero";
import SemaineDesAssos from "./pages/events/semDesAss24";
import RoshHashana from "./pages/events/rosh_hashana2024";
import Conference1 from "./pages/events/conference1";
import Conference2 from "./pages/events/conference2";
import Shabbat from "./pages/events/shabbat";
import Chalets2024 from "./pages/events/chalets2024";
import BecomeAMember from "./pages/about/BecomeAMember";
import ComiteeMembers from "./pages/about/ComiteeMembers";

function App() {
  return (
    <Router>
      <ScrollToTop />
        <Routes>
          <Route element={<Layout />}>
            <Route path="*" element={<Home />} />
            <Route path="/become-a-member" element={<BecomeAMember />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/donation" element={<Donate />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/activities" element={<Activities />} />
            <Route path="/statuts" element={<Statuts />} />
            <Route path="/creation" element={<Creation />} />
            <Route path="/vivap24" element={<Vivap24 />} />
            <Route path="/vivap25" element={<Vivap25 />} />
            <Route path="/welcomeApero" element={<WelcomeApero />} />
            <Route path="/semDesAss24" element={<SemaineDesAssos />} />
            <Route path="/rosh_hashana2024" element={<RoshHashana />} />
            <Route path="/conference1" element={<Conference1 />} />
            <Route path="/conference2" element={<Conference2 />} />
            <Route path="/shabbat" element={<Shabbat />} />
            <Route path="/chalets2024" element={<Chalets2024 />} />
            <Route path="/comitee-members" element={<ComiteeMembers />} />
          </Route>
        </Routes>
    </Router>
  );
}

export default App;